import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const LegalLayout = ({ title, subtitle, children }) => (
  <div className="bg-[#0a0a0b] text-neutral-100 min-h-screen">
    <div className="relative border-b border-neutral-900">
      <div className="absolute inset-0 bg-grid opacity-25 pointer-events-none" />
      <div className="mx-auto max-w-3xl px-6 lg:px-10 pt-28 pb-16 relative">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.28em] font-mono-tech text-neutral-400 hover:text-[#ff5a00] transition-colors mb-8"
        >
          <ArrowLeft size={14} /> Anasayfaya Dön
        </Link>
        <div className="flex items-center gap-3 mb-5">
          <span className="w-6 h-px bg-[#ff5a00]" />
          <span className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#ff5a00]">
            Yasal Metinler
          </span>
        </div>
        <h1 className="font-display text-4xl md:text-5xl font-semibold tracking-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-4 text-neutral-400 text-sm md:text-base max-w-xl">
            {subtitle}
          </p>
        )}
      </div>
    </div>
    <article className="mx-auto max-w-3xl px-6 lg:px-10 py-16 prose-legal">
      {children}
    </article>
    <div className="mx-auto max-w-3xl px-6 lg:px-10 pb-16 font-mono-tech text-[10px] uppercase tracking-[0.28em] text-neutral-600">
      Son güncelleme: Aralık 2025 · MoDuLerİS
    </div>
  </div>
);

export default LegalLayout;
